import { io } from 'socket.io-client'

// ─── Socket.IO Client Singleton ────────────────────────────────────────────
// JWT token ile bağlanır (localStorage'dan okur). Backend `/api/v1/...` axios
// baseURL'iyle aynı origin'i kullanır (port 3000).
//
// Kullanım:
//   import socket from '@/libs/socket'
//   socket.on('event-name', handler)
//   socket.emit('bot:subscribe', botId)
//   socket.disconnect()
//
// Auto-reconnect aktif; token expired olursa connect_error gelir.

// Build-time env: dev'de boş → fallback http://localhost:3000
// Docker prod'da VUE_APP_SOCKET_URL='' set edilir; boş ise io() current origin'e
// bağlanır (window.location.origin) — nginx reverse proxy /socket.io'yu backend'e iletir.
const SOCKET_URL = process.env.VUE_APP_SOCKET_URL !== undefined
  ? process.env.VUE_APP_SOCKET_URL
  : 'http://localhost:3000'

let _socket = null

export function getSocket() {
  if (_socket) return _socket

  const token = localStorage.getItem('accessToken')
  if (!token) {
    console.warn('[socket] no accessToken yet — call connectSocket() after login')
    return null
  }

  _socket = io(SOCKET_URL, {
    transports: ['websocket', 'polling'],
    auth: { token },
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 10000,
  })

  _socket.on('connect', () => {
    console.info('[socket] connected sid=', _socket.id)
  })
  _socket.on('connect_error', err => {
    console.warn('[socket] connect_error:', err.message)
  })
  _socket.on('disconnect', reason => {
    console.info('[socket] disconnected:', reason)
  })

  return _socket
}

export function connectSocket() {
  // Idempotent connect — login sonrası çağrılır
  if (_socket && _socket.connected) return _socket
  if (_socket) { _socket.connect(); return _socket }
  return getSocket()
}

export function disconnectSocket() {
  if (_socket) {
    _socket.disconnect()
    _socket = null
  }
}

export default {
  get instance() { return _socket },
  getSocket,
  connectSocket,
  disconnectSocket,
}
